
import { defineComponent } from 'vue';
import TheTopLogo from '@/components/organisms/TheTopLogo.vue';
import ContentBox from '@/components/molecules/ContentBox.vue';
import Heading from '@/components/atoms/Heading.vue';
import LinkButton from '@/components/organisms/utils/LinkButton.vue';
import { getIsIos } from '@/libs/utils/device';

export default defineComponent({
  name: 'TopTemplate',
  components: {
    TheTopLogo,
    ContentBox,
    Heading,
    LinkButton,
  },
  props: {
    i18n: {
      type: Object,
    },
  },
  mounted: function() {
    if (getIsIos()) {
      document.body.className = 'is-ios';
    }
  },
});
